import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { Calendar } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function VeterinaryConsultationsPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Consultas"
      description="Gerencie as consultas da sua clínica veterinária."
      icon={Calendar}
    />
  
    </MainLayout>);
}

